const safeSum = (a?: number, b?: number) => {
  if (!a || isNaN(a)) a = 0;
  if (!b || isNaN(b)) b = 0;
  return a + b;
};

type ItemWithQuantity = {
  quantity?: number;
};

export const sumItemQuantities = (items: (ItemWithQuantity | undefined)[] | undefined) => {
  if (!items) {
    return 0;
  }
  return items?.reduce((total, item) => safeSum(total, item ? item.quantity ?? 1 : 0), 0);
};

type ItemWithItems = {
  items?: ItemWithQuantity[];
};
export const sumAllItemQuantities = (item: (ItemWithItems | undefined)[]) => {
  return item?.reduce((total, i) => safeSum(total, sumItemQuantities(i?.items)), 0) || 0;
};
